import React from 'react'
import * as H from 'history'
import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import { ProfilePayload } from '../models/ProfilePayload'
import { ProfileController } from '../controllers/ProfileController'
import {
  TextField, AbnField, AddressField, PhoneField, EmailField, validateFields,
} from '../shared/fields'
import { ISupportSpinner } from '../shared/Ajax'
import { Backdrop } from '../shared/Backdrop'
import { Dialog } from '../shared/Dialog'
import { ProfileModel } from '../models/ProfileModel'
import { TimeoutPopup } from '../shared/TimeoutPopup'

export interface ProfilePageProps {
    history: H.History
}

export interface ProfilePageState extends ProfilePayload {
    loading: boolean
    dialog: boolean
}

export class ProfilePage extends React.Component<ProfilePageProps, ProfilePageState> implements ISupportSpinner {
  address: AddressField
  phone: PhoneField
  mobile: PhoneField
  email: EmailField

  ajax: ProfileController

  constructor(props: ProfilePageProps) {
    super(props)

    this.ajax = new ProfileController()

    this.state = {
      loading: false,
      model: {
        abn: '',
        accountType: '',
        email: '',
        firstName: '',
        lastName: '',
        mobile: '',
        phone: '',
        registredName: '',
        title: '',
        address: null,
      },
      requestedAccountType: '',
      dialog: false,
      addressCountries: [],
    }
  }

  componentDidMount() {
    this.ajax.get(this, (p) => {
      this.setState(p)
    })
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  updateContactDetails = () => {
    validateFields((res) => {
      if (res) {
        this.ajax.updateContact(this, { ...this.state.model }, () => { })
      }
    },
    this.address,
    this.phone,
    this.mobile,
    this.email,
    )
  }

  onChange = (change: Partial<ProfileModel>) => {
    this.setState({
      model: { ...this.state.model, ...change },
    })
  }

  changeAccountType = () => {
    this.props.history.push('/profile/request')
  }

  cancel = () => {
    if (confirm('Do you want to cancel your request?')) {
      this.ajax.cancelRequest(this, () => {
        this.setState({ requestedAccountType: null })
      })
    }
  }

  closeDialog = () => {
    this.setState({ dialog: false })
  }

  render() {
    return (
      <div className="container-fluid pt-2">
        <div className="row">
          <div className="col-lg-9">
            <h2>My Profile</h2>
            <div className="clearfix">
              <TextField
                className="float-left mr-3"
                id="contacFirstName"
                label="First Name"
                value={this.state.model.firstName}
                required
                onChange={(v) => { }}
                disabled
              />
              <TextField
                className="float-left"
                id="contacLastName"
                label="Last Name"
                value={this.state.model.lastName}
                required
                onChange={(v) => { }}
                disabled
              />
            </div>
            <AbnField
              id="abn"
              label="Australian Business Number (ABN)"
              value={this.state.model.abn}
              required
              block={false}
              onChange={(v) => { }}
              disabled
            />
            <TextField
              id="registredName"
              label="Registered business name as per ABR record"
              value={this.state.model.registredName}
              required
              onChange={(v) => { }}
              disabled
            />

            <Button onClick={() => this.setState({ dialog: true })} className="emdg-btn emdg-btn--secondary mt-3">Change above details</Button>

            <AddressField
              ref={(r) => this.address = r}
              id="address"
              label="Address"
              value={this.state.model.address}
              onChange={(address) => this.onChange({ address })}
              required
              disabled
              countries={this.state.addressCountries}
            />

            <PhoneField
              ref={(r) => this.phone = r}
              id="phone"
              label="Telephone number (e.g. +61 2 9999 9999)"
              value={this.state.model.phone}
              onChange={(phone) => this.onChange({ phone })}
              required
              disabled
              block={false}
            />
            <PhoneField
              ref={(r) => this.mobile = r}
              id="mobile"
              label="Mobile phone number (e.g. +61 499 999 999)"
              value={this.state.model.mobile}
              onChange={(mobile) => this.onChange({ mobile })}
              disabled
              block={false}
            />
            <EmailField
              ref={(r) => this.email = r}
              id="email"
              label="Email"
              value={this.state.model.email}
              onChange={(email) => this.onChange({ email })}
              disabled
              required
            />
            <Alert className="emdg-page-alerts">
              <p>Please email emdg.help@austrade.gov.au to update your details.</p>
            </Alert>

            <Dialog
              id="years"
              title="How to change your details"
              open={this.state.dialog}
              onClose={this.closeDialog}
              footer={<Button className="emdg-btn emdg-btn--secondary" onClick={this.closeDialog}>Close</Button>}
            >
              <p>You name and company details are linked to your myGovId.</p>
              <p>Please contact ATO to update those details.</p>
            </Dialog>

            <Backdrop on={this.state.loading} />
          </div>
        </div>
        <TimeoutPopup />
      </div>
    )
  }
}
